/** Minimum characters before server-side company name search runs. */
export const AGENT_COMPANY_SEARCH_MIN_LENGTH = 2;

/** Parse agent booking search input into a numeric booking id, if applicable. */
export const parseAgentBookingIdSearch = (input: string): number | null => {
  const trimmed = input.trim();
  if (!trimmed) return null;

  if (/^\d+$/.test(trimmed)) {
    return parseInt(trimmed, 10);
  }

  const effMatch = trimmed.match(/^eff\s*(\d+)$/i);
  if (effMatch) {
    return parseInt(effMatch[1], 10);
  }

  return null;
};
